// extracted by mini-css-extract-plugin
export default {"CheckboxWrapper":"LabeledCheckbox_CheckboxWrapper__2Bx8y","Right":"LabeledCheckbox_Right__B3N+x"};